import { memo, useContext, useState } from 'react';
import { AiOutlineTool } from 'react-icons/ai';
import { ButtonsContainerSubItem } from './FormStyle';
import FormSubitemModal from './Modals/FormSubitemModal';
import { useTranslation } from 'react-i18next';
import ConfirmationModal from '../ConfirmationModal/ConfirmationModal';
import { ChecklistSubitem, ChecklistType, ItemChecklist } from '../../service/Checklists';
import { FaEye } from "react-icons/fa";
import { UserContext, identifierTypesList } from '../../context/UserContext';
import { trackEventMatomo } from '../../helpers/matomo';
import { ButtonGroup, IconButton, TableCell } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const questionKey = 'checklists.subitemModal.questionTypes.';

export type FormSubitemProp = {
  subitem: ChecklistSubitem,
  index: number,
  indexItem: number,
  isEditing: boolean,
  setEditingForm: Function,
  form: ChecklistType,
  item: ItemChecklist,
  setSubModalOpen: Function,
  selectedIdentifica: string | undefined
};


function FormSubItem({
  subitem,
  index,
  indexItem,
  isEditing,
  setEditingForm,
  setSubModalOpen,
  form,
  item,
  selectedIdentifica
}
  : FormSubitemProp) {
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [editSubModalOpen, setEditSubModalOpen] = useState(false);

  const { identifiersByForm, setIdentifiersByForm } = useContext(UserContext);
  const { t } = useTranslation('translation');

  const optionsSelectMap = {
    avaliacao: t(questionKey + 'avaliation'), multiple: t(questionKey + 'multiple'),
    unique: t('singleSelection'),
    textoCurto: t(questionKey + 'shortText'), textoLongo: t(questionKey + 'longText'),
    list: t('textList'),
    data: t(questionKey + 'date'), hora: t(questionKey + 'hour'),
    numero: t(questionKey + 'number'), assinatura: t(questionKey + 'signature'),
    email: t('email'), telefone: t('tel'),
    rg: 'RG', cpfcnpj: 'CPF/CNPJ',
    cep: 'CEP', placa: t('licensePlate')
  };

  const handleDelete = () => {
    trackEventMatomo('Gestão de formulários', 'click', 'button', 'duplica subitem');
    form.itens[indexItem].subitens = form.itens[indexItem].subitens.filter((_e, i) => i !== index);
    if (identifierTypesList.includes(subitem.tipo)) {
      const subIdentifi = `${form.id}|${form.versao}|${indexItem}|${index}`;
      const thisIdentifierList = identifiersByForm.find(e => e.formId === form.id)?.identifiersList;
      if (form.identificadorLista === subIdentifi) {
        form.identificadorLista = '';
      }
      const newIdentifiers = thisIdentifierList?.filter(e => e.value !== subIdentifi);
      identifiersByForm.forEach(e => {
        if (newIdentifiers !== undefined && e.formId === form.id) {
          e.identifiersList = newIdentifiers;
        }
      });
      setIdentifiersByForm([...identifiersByForm]);
    }
    setEditingForm({ ...form });
    setConfirmationModal(false);
  };

  const handleDuplicate = () => {
    trackEventMatomo('Gestão de formulários', 'click', 'button', 'duplica subitem');
    const thisSubItem = { ...subitem };
    delete thisSubItem.help;
    thisSubItem.nome = `${thisSubItem.nome} ${t('copy')}`;
    thisSubItem.id = item.subitens?.length;
    thisSubItem.itemid = item?.id;
    if (thisSubItem.avaliacao) {
      const newAvaliation = JSON.parse(JSON.stringify(thisSubItem.avaliacao));
      thisSubItem.avaliacao = newAvaliation;
    }

    form.itens[indexItem].subitens.push(thisSubItem);
    setEditingForm({ ...form });
  };

  return (
    <>
      <TableCell align='center'>
        {confirmationModal && <ConfirmationModal
          yesFunction={handleDelete}
          isOpen={confirmationModal}
          closeFunction={setConfirmationModal}
        />}
        {editSubModalOpen && (
          <FormSubitemModal
            selectedIdentifica={selectedIdentifica}
            item={item}
            fatherIndex={indexItem}
            thisIndex={index}
            subItem={subitem}
            editSubModalOpen={editSubModalOpen}
            setEditSubModalOpen={setEditSubModalOpen}
            isEditing={isEditing}
            setEditingForm={setEditingForm}
            form={form}
            setSubModalOpen={setSubModalOpen}
          />
        )}
        {`${indexItem + 1}.${index + 1}`}</TableCell>
      <TableCell
        key={subitem.nome}
        align='left'
        style={{
          wordWrap: 'break-word',
          wordBreak: 'break-word'
        }}>
        {subitem.nome}
      </TableCell>
      <TableCell align="center">{optionsSelectMap[subitem.tipo as keyof typeof optionsSelectMap]}</TableCell>
      <TableCell align="center">{typeof subitem.peso !== "number" ? '-' : subitem.peso}</TableCell>
      <TableCell align="center">
        <ButtonGroup>
          <ButtonsContainerSubItem>
            {!isEditing ?
              <IconButton
                onClick={() => {
                  trackEventMatomo('Gestão de formulários', 'click', 'button', 'abre modal de subitem');
                  const x = { ...subitem };
                  subitem = x;
                  setEditSubModalOpen(true);
                }}
              >

                <FaEye />
              </IconButton>
              : <IconButton
                onClick={() => {
                  trackEventMatomo('Gestão de formulários', 'click', 'button', 'abre modal de subitem');
                  const x = { ...subitem };
                  subitem = x;
                  setEditSubModalOpen(true);
                  setSubModalOpen(true);
                }}
                disabled={!isEditing}
              >
                <AiOutlineTool />
              </IconButton>


            }
            <IconButton
              disabled={!isEditing}
              onClick={handleDuplicate}
            >
              <ContentCopyIcon color='success' />
            </IconButton>
            <IconButton
              onClick={() => {
                trackEventMatomo('Gestão de formulários', 'click', 'button', 'deleta subitem');
                setConfirmationModal(true);
              }}
              disabled={!isEditing || item.subitens.length === 1}
            >
              <DeleteIcon color='error' />
            </IconButton>
          </ButtonsContainerSubItem>
        </ButtonGroup>
      </TableCell>
    </>
  );
}

export default memo(FormSubItem);